import React, { useState, useEffect } from "react";
import {
  Toolbar,
  Grid,
  Button,
  Card,
  CardContent,
                      
} from "@material-ui/core";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import CustomInput from "components/custom/CustomInput";
import KisshtTable from "components/table/KisshtTable";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import { IsEmpty } from "shared/utils";
import KisshtButton from "components/ui/KisshtButton";
import { GlobalHeader } from 'components/navigation/components/GlobalHeader';
import EditIcon from "@material-ui/icons/Edit";
import AddPlebgraphConfiguration from "./Dialog/addplebgrahconfig";
import { getConfigurationList } from "shared/api/configurations";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import {PERMISSIONS, ROUTE_NAME } from "shared/constants";
import PermissionButton from "components/ui/form/PermissionButton";
import PlebgraphViewConfig from "./Dialog/PlebgraphViewConfig";
import VisibilityIcon from "@material-ui/icons/Visibility";


  let offset = 1;

export const PlebgraphCongiguration = (props) => {
  const { params, updateQueryParams, delteQueryParams } = props;
    const [configData, setConfigData] = useState([]);
    const [spinning, setSpinning] = useState(false);
    const [openConfigModal, setopenConfigModal] = useState(false);
    const [editData, seteditData] = useState(null);
    const [isEditing, setisEditing] = useState(false);
    const [search, setSearch] = useState(params["search"] || "");
    const [reload, setReload] = useState(false);
    const [openViewModal, setopenViewModal] = useState(false);
    const [showConfigData,setShowConfigData] = useState(null)
    
    

    const fetchConfigurationListing = async () => {
      setSpinning(true);
      await updateQueryParams({ search });
      let payload={
        per_page:20,
        page_no:offset-1,
        merchant_reference_number : "MERT1867685187882O9R"
      }
      await getConfigurationList(search,payload)
        .then((res) => {
          setSpinning(false);
          if (res.hasOwnProperty("success") && res.success) {
            const { data } = res;
            if (
              data &&
              data.hasOwnProperty("configuration") &&
              data.configuration.length > 0
            ) {
              setConfigData(data.configuration);
            } else {
              setConfigData([]);
            }
          }
        })
        .catch((error) => {
          setSpinning(false);
        });
    };
  
    useEffect(() => {
      fetchConfigurationListing();
    }, [search]);

    useEffect(() => {
      if (offset === 1) {
        fetchConfigurationListing();
      }
    }, [reload]);


    const editClickHandler = async (cell) => {
        seteditData(cell);
        setisEditing(true);
        setopenConfigModal(true);
     };
    
     
    const viewClickHandler = (cell) =>{
      setopenViewModal(true)
      setShowConfigData(cell.original);

    }
    const handleViewModalClosed = () =>{
      setopenViewModal(false)
    }

     const handleModalClosed = (sts) => {
        seteditData(null);
        if (sts) {
          setopenConfigModal(false);
          fetchConfigurationListing();
        } else {
          setopenConfigModal(sts);
        }
      };
      const columns = [
        {
          Header: "Title",
          accessor: "title",
          sortable: false,
          filterable: false,
          headerClassName:"common_medium_tablewidth",
          Cell: (cell) => {
            return <IsEmpty value={"title"} itemKey={cell.original} />;
          },
        },
        {
          Header: "Meta Key",
          accessor: "meta_key",
          sortable: false,
          filterable: false,
          headerClassName:"common_medium_tablewidth",
          Cell: (cell) => {
            return <IsEmpty value={"meta_key"} itemKey={cell.original} />;
          },
        },
        {
          Header: "Meta Value",
          accessor: "meta_value",
          filterable: false,
          sortable: false,
          headerClassName:"common_medium_tablewidth",
          Cell: (cell) => {
            return <IsEmpty value={"meta_value"} itemKey={cell.original} />;
          },
        },
        {
          Header: "Meta Data Type",
          accessor: "meta_data_type",
          filterable: false,
          sortable: false,
          headerClassName:"report_download_column",
          Cell: (cell) => {
            return <IsEmpty value={"meta_data_type"} itemKey={cell.original} />;
          },
        },
        {
          Header: "Status",
          accessor: "status",
          filterable: false,
          sortable: false,
          headerClassName:"report_download_column",
          Cell: (cell) => {
            return <BootstrapBadge fontSize={"0.8rem"} text={cell.value} />;
          },
        },
        {
          Header: "Action",
          headerClassName:"report_download_column",
          // show:(PERMISSIONS.custom_config.update ? true:false), 
          Cell: (cell) => {
            return (
              <Grid container>
                <Grid>
                  <PermissionButton
                    endIcon={<VisibilityIcon />}
                    style={{border:'none'}} 
                    size="small"
                    variant="outlined"
                    route={ROUTE_NAME.plebgraph_configuration}
                    permission={PERMISSIONS.plebgraph_configuration.view}
                    onClick={() => viewClickHandler(cell)}
                    >
                  </PermissionButton>
                </Grid>
                <Grid>
                  <PermissionButton
                    endIcon={<EditIcon />}
                    style={{border:'none'}}
                    size="small"
                    variant="outlined"
                    route={ROUTE_NAME.plebgraph_configuration}
                    permission={PERMISSIONS.plebgraph_configuration.update}
                    onClick={() => editClickHandler(cell.original)}
                    >
                  </PermissionButton>
                </Grid>
              </Grid>
             
            );
          },
          filterable: false,
        },
      ];

      const onPageChange = async (value) => {
        offset = value;
        fetchConfigurationListing();
      };
      const handleSearch = async (e) => {
        e.preventDefault();
        if (search) {
          if (!search && !search.length) return false;
          offset = 1;
          await fetchConfigurationListing();
        }
      };

      const refreshHandler = async (_) => {
        await delteQueryParams();
        setSearch(null);
        offset = 1;
        setReload(!reload);
      };

    return(
        <>
        <Header open={props.open}>
        <Toolbar
            style={{
              backgroundColor: Colors["AppBarBGPurple"],
              minHeight: "65px",
            }}
          >
            <GlobalHeader />
          </Toolbar>
          <Toolbar>
            <Grid container alignItems="center"  className="crum_padding">
            <Grid container alignItems="center" >
                <Grid item lg={3} md={3} sm={4} xs={4}>
                      <BreadcrumbsHeader text="Plebgraph Configurations Table" />
                </Grid>
                <Grid item lg={9} md={9} sm={8} xs={12} className='top_spacing_btn'>
                  <Grid container justifyContent="flex-end" alignItems="center">
                    <KisshtButton
                      onClick={() => {
                        setisEditing(false);
                        setopenConfigModal(true);
                      }}
                      size="small"
                      variant="outlined"
                      color="secondary"
                      className="common_kissht_btn"
                      route={ROUTE_NAME.plebgraph_configuration}
                      permission={PERMISSIONS.plebgraph_configuration.create}
                    >
                      Add Configration
                    </KisshtButton>  
                  </Grid>
                </Grid>
            </Grid>
              <Grid item xs={12} className="crum_innerPadding">
                <Grid container spacing={1} alignItems="center">
                  <Grid item>
                    <CustomInput
                      placeholder="Search"
                      onChange={(e) => setSearch(e.target.value)}
                      value={search || ""}
                      className="common_custom_input"
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      disabled={search ? false : true}
                      variant="contained"
                      className="shadow-none common_kissht_btn"
                      color="primary"
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                     onClick={refreshHandler} 
                     size="small" color="primary">
                      Reset
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Toolbar>
        </Header>
  
        <div className="common_padding_from_title_withLessFilter ">
          <Card
            style={{
              boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,
            }}
          >
            <CardContent style={{ height: "50px" }}>
              <Grid container className="grid-vertical-align-center">
                <Grid item xs={12}>
                  <p
                    className="text-xs"
                    style={{
                      color: Colors["lightPurple"],
                      margin: "auto",
                    }}
                  ></p>
                </Grid>
              </Grid>
            </CardContent>
            <CardContent className='table_card_mobile'>
              <KisshtTable
                loading={spinning}
                columns={columns}
                data={configData}
                onPageChange={onPageChange}
                showPagination={true}
                offset={offset}
                totalCount={offset && 1000}
              />
            </CardContent>
          </Card>
        </div>
        {openConfigModal && (
          <AddPlebgraphConfiguration
            visible={openConfigModal}
            callbackEvent={handleModalClosed}
            data={editData}
            isEditing={isEditing}
          ></AddPlebgraphConfiguration>
        )}
        {openViewModal && (
          <PlebgraphViewConfig
            visible={openViewModal}
            onClose={handleViewModalClosed}
            data={showConfigData}

          />
        )}
        
      </>
    )
}

export default PlebgraphCongiguration;